import type { TariffFeature } from 'src/types/tariff';

import type { AnyTool } from './tool-types';

export type TariffVerdict = { allowed: true } | { allowed: false; feature: TariffFeature };

export const checkToolTariff = (
  tool: AnyTool,
  canUseFeature: (feature: TariffFeature) => boolean
): TariffVerdict => {
  const feature = tool.tariffFeature;

  if (!feature || canUseFeature(feature)) {
    return { allowed: true };
  }
  return { allowed: false, feature };
};
